<template>
  <v-container fluid px-0 mt-0>
    <v-expansion-panels v-model="panel" multiple focusable hover readonly="">
      <v-expansion-panel :key="0">
        <v-expansion-panel-header>
          Servicios Disponibles
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container fluid px-0 pt-5>
            <v-row>
              <v-col md="12">
                <v-row v-if="loading">
                  <v-flex
                    v-for="i in [1, 2, 3, 4, 5, 6]"
                    :key="'sl_sd_' + i"
                    cols="12"
                    md="2"
                    sm="3"
                    xs="6"
                    text-sm-right
                    px-3
                  >
                    <v-skeleton-loader type="image" />
                  </v-flex>
                </v-row>
                <v-row v-else-if="serviciosDisponibles.length > 0">
                  <v-col
                    v-for="i in serviciosDisponibles"
                    :key="'sl_serv_disp_' + i.idServicio"
                    cols="12"
                    md="2"
                    sm="3"
                    xs="6"
                  >
                    <icono-servicio-disponible
                      :servicio="i"
                      :go-url-solicitud="true"
                    />
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12" md="12" xs="12">
                    <v-alert type="info">
                      No hay servicios disponibles.
                    </v-alert>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-snackbar
      key="snackbar_expansionpanelsserviciosdisponibles"
      v-model="snackbarError"
      :bottom="true"
      :multi-line="true"
      color="error"
    >
      {{ textoError }}
      <v-btn dark text @click="snackbarError = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { getServiciosDisponiblesExterno } from "@/api";

export default {
  name: "ExpansionPanelsServiciosDisponibles",
  components: {
    IconoServicioDisponible: () =>
      import("../../components/atoms/IconoServicioDisponible"),
  },
  props: {},
  data() {
    return {
      panel: [0],
      loading: true,
      serviciosDisponibles: [],
      snackbarError: false,
      textoError: "",
    };
  },
  computed: {},
  mounted() {
    this.getServiciosDisponibles();
  },
  methods: {
    async getServiciosDisponibles() {
      var self = this;
      self.loading = true;
      self.serviciosDisponibles = [];

      try {
        let response = await getServiciosDisponiblesExterno();

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              response.data.data.forEach(function(item) {
                //console.log(item)
              });
              self.serviciosDisponibles = response.data.data;
              self.snackbarError = false;
              self.textoError = "";
            }
          } else {
            self.snackbarError = true;
            self.textoError = response.data.message;
          }
        } else {
          self.snackbarError = true;
          self.textoError = "Error de red";
        }

        self.loading = false;
      } catch (e) {
        self.loading = false;

        self.snackbarError = true;
        self.textoError = e;
      }
    },
  },
};
</script>
